export const routes = (parentName) => {
  return [
    {
      path: "discounts",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Discounts`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Discounts-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Discounts-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Discounts-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Discounts-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
